import React from 'react';
import Icon from '../../../components/AppIcon';

const FailedTransactionsPanel = ({ metrics, loading }) => {
  if (loading) {
    return (
      <div className="bg-card rounded-xl border border-border p-6">
        <div className="animate-pulse">
          <div className="h-6 bg-gray-200 rounded w-1/3 mb-4" />
          <div className="space-y-3">
            <div className="h-16 bg-gray-200 rounded" />
            <div className="h-16 bg-gray-200 rounded" />
            <div className="h-16 bg-gray-200 rounded" />
          </div>
        </div>
      </div>
    );
  }

  const transactions = [
    {
      label: 'Failed Payments',
      value: metrics?.failedPayments || 0,
      icon: 'CreditCard',
      color: 'text-red-600',
      bgColor: 'bg-red-50',
      description: 'Stripe payment failures'
    },
    {
      label: 'Failed Signups',
      value: metrics?.failedSignups || 0,
      icon: 'UserX',
      color: 'text-orange-600',
      bgColor: 'bg-orange-50',
      description: 'Registration errors'
    },
    {
      label: 'Failed Check-ins',
      value: metrics?.failedCheckIns || 0,
      icon: 'XCircle',
      color: 'text-yellow-600',
      bgColor: 'bg-yellow-50',
      description: 'Symptom entry errors'
    }
  ];

  return (
    <div className="bg-card rounded-xl border border-border p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-lg font-heading font-semibold text-foreground flex items-center gap-2">
          <Icon name="XOctagon" size={20} strokeWidth={2} />
          Failed Transactions
        </h2>
        <div className="flex items-center gap-2">
          <span className="text-2xl font-bold text-foreground">
            {metrics?.totalFailures || 0}
          </span>
          {metrics?.trend !== 0 && (
            <div className={`flex items-center gap-1 text-sm ${
              metrics?.trend > 0 ? 'text-red-600' : 'text-green-600'
            }`}>
              <Icon 
                name={metrics?.trend > 0 ? 'TrendingUp' : 'TrendingDown'} 
                size={16} 
                strokeWidth={2} 
              />
              {Math.abs(metrics?.trend)}%
            </div>
          )}
        </div>
      </div>
      <div className="space-y-3">
        {transactions?.map((transaction, index) => (
          <div
            key={index}
            className={`${transaction?.bgColor} border border-gray-200 rounded-lg p-4`}
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className={`${transaction?.color}`}>
                  <Icon name={transaction?.icon} size={24} strokeWidth={2} />
                </div>
                <div>
                  <p className="font-semibold text-foreground">{transaction?.label}</p>
                  <p className="text-sm text-muted-foreground">{transaction?.description}</p>
                </div>
              </div>
              <div className="text-right">
                <p className={`text-2xl font-bold ${transaction?.color}`}>
                  {transaction?.value}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FailedTransactionsPanel;